import { useState } from 'react';

// Ô "Tạo trạng thái kết quả để nhân viên chọn" — DÙNG CHUNG cho mọi màn tạo công việc.
// Controlled: enabled + onEnabled (bật/tắt), statuses + onStatuses (mảng trạng thái).
// Khi báo cáo, NV chọn 1 trạng thái cho mỗi KH; TP duyệt xong hệ thống tính tỷ lệ theo trạng thái.
export default function ResultStatusesField({ enabled, onEnabled, statuses, onStatuses }) {
  const [input, setInput] = useState('');

  function add() {
    const v = input.trim();
    if (!v) return;
    if (!statuses.includes(v)) onStatuses([...statuses, v]);
    setInput('');
  }

  return (
    <>
      <div className="field">
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
          <input type="checkbox" style={{ width: 'auto' }} checked={enabled} onChange={(e) => onEnabled(e.target.checked)} />
          Tạo trạng thái kết quả để nhân viên chọn (vd: Đã liên hệ khách, KH đã quay lại…)
        </label>
      </div>
      {enabled && (
        <div className="card" style={{ background: 'var(--panel2)' }}>
          <div className="row" style={{ gap: 8 }}>
            <input
              style={{ flex: 1 }}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), add())}
              placeholder="Nhập 1 trạng thái rồi bấm Thêm…"
            />
            <button type="button" className="btn sm" onClick={add}>
              + Thêm
            </button>
          </div>
          <div style={{ marginTop: 10 }}>
            {statuses.length ? (
              statuses.map((s) => (
                <span className="tag" key={s} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  {s}
                  <span style={{ cursor: 'pointer', color: 'var(--danger)', fontWeight: 700 }} onClick={() => onStatuses(statuses.filter((x) => x !== s))}>
                    ×
                  </span>
                </span>
              ))
            ) : (
              <span className="small muted">Chưa có trạng thái nào. Thêm ít nhất 1 trạng thái.</span>
            )}
          </div>
          <div className="small muted" style={{ marginTop: 8 }}>
            Khi báo cáo, nhân viên chọn 1 trạng thái cho mỗi KH (vẫn note nội dung cụ thể). Sau khi TP duyệt, hệ thống tính tỷ lệ KH theo từng trạng thái (trên các KH được duyệt đạt).
          </div>
        </div>
      )}
    </>
  );
}
